<template>
  <div class="px-10px pt-10px text-14px h-full overflow-auto">
    <div class="flex justify-start items-start mb-10px mt-10px">
      <img src="../../assets/images/titleIcon.png" alt />
      <span class="text-16px text-white ml-4px">基本信息</span>
    </div>
    <div class="h-160px border border-hex-4d9bbf border-solid relative pt-35px px-18px">
      <div class="h-100px flex text-white">
        <div class="w-100px h-full mr-15px">
          <img
            class="w-full h-full object-contain border border-gray-500/20"
            :src="personnelDetail.facePhotoImg ? personnelDetail.facePhotoImg : null"
            alt
          />
        </div>
        <div class="flex flex-col justify-between flex-1 overflow-hidden">
          <div class="flex">
            <div class="text-hex-45f2eb mr-5px">访客姓名：</div>
            <div class="flex-1 truncate" :title="personnelDetail.name">
              {{ personnelDetail.name }}
            </div>
          </div>
          <div class="flex">
            <div class="text-hex-45f2eb mr-5px">性别：</div>
            <div class="flex-1 truncate" :title="personnelDetail.sexStr">
              {{ personnelDetail.sexStr }}
            </div>
          </div>
          <div class="flex">
            <div class="text-hex-45f2eb mr-5px">联系电话：</div>
            <div class="flex-1 truncate" :title="personnelDetail.contactNumber">
              {{ personnelDetail.contactNumber }}
            </div>
          </div>
          <div class="flex">
            <div class="text-hex-45f2eb mr-5px">被访部门：</div>
            <div class="flex-1 truncate" :title="personnelDetail.intervieweeDepartment">
              {{ personnelDetail.intervieweeDepartment }}
            </div>
          </div>
          <div class="flex">
            <div class="text-hex-45f2eb mr-5px">被访人：</div>
            <div class="flex-1 truncate" :title="personnelDetail.intervieweeName">
              {{ personnelDetail.intervieweeName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="flex justify-start items-start mb-10px mt-10px">
        <img src="../../assets/images/titleIcon.png" alt />
        <span class="text-16px text-white ml-4px">来访信息</span>
      </div>
      <div class="text-white">
        <div class="flex mb-10px">
          <div class="text-hex-45f2eb mr-5px">工作单位：</div>
          <div class="flex-1 truncate" :title="personnelDetail.workplace">
            {{ personnelDetail.workplace }}
          </div>
        </div>
        <div class="flex mb-10px">
          <div class="text-hex-45f2eb mr-5px">来访事由：</div>
          <div class="flex-1 truncate" :title="personnelDetail.visitReason">
            {{ personnelDetail.visitReason }}
          </div>
        </div>
        <div class="flex mb-10px">
          <div class="text-hex-45f2eb mr-5px">证件类型：</div>
          <div class="flex-1 truncate" :title="personnelDetail.documentTypeName">
            {{ personnelDetail.documentTypeName }}
          </div>
        </div>
        <div class="flex mb-10px">
          <div class="text-hex-45f2eb mr-5px">证件号码：</div>
          <div class="flex-1 truncate" :title="personnelDetail.documentNumber">
            {{ personnelDetail.documentNumber }}
          </div>
        </div>
        <div>
          <div class="text-hex-45f2eb mb-10px">证件图片：</div>
        </div>
        <el-image
          v-if="personnelDetail.documentImg"
          class="w-full"
          :src="personnelDetail.documentImg"
          :preview-src-list="[personnelDetail.documentImg]"
        >
        </el-image>
        <div class="flex mb-10px">
          <div class="text-hex-45f2eb mr-5px">来访时间：</div>
          <div class="flex-1 truncate" :title="personnelDetail.validTime">
            {{ personnelDetail.intervieweeName }}
          </div>
        </div>
        <div class="flex mb-10px">
          <div class="text-hex-45f2eb mr-5px">是否访问生产区：</div>
          <div class="flex-1 truncate" :title="personnelDetail.visitProductionAreaStr">
            {{ personnelDetail.visitProductionAreaStr }}
          </div>
        </div>
      </div>
      <div class="flex text-white text-16px justify-between mb-30px">
        <div
          class="flex items-center justify-center w-90px h-33px cursor-pointer"
          :class="currentBtn === 'trajectory' ? 'btn_choosed' : 'btn_normal'"
          @click="searcheTrajectory"
        >
          轨迹查询
        </div>
        <div
          class="flex items-center justify-center w-90px h-33px cursor-pointer"
          :class="currentBtn === 'locationTracking' && isFollow ? 'btn_choosed' : 'btn_normal'"
          @click="track"
        >
          {{ isFollow ? '取消追踪' : '位置追踪' }}
        </div>
      </div>
      <div v-if="currentBtn === 'locationTracking' && isFollow">
        <CategoryTitle title="视频联动" />
        <MonitorPlayer
          v-if="currentMonitor"
          :manufacturerCode="currentMonitor.manufacturerCode"
          :daHuaParams="{
            id: currentMonitor.id,
            code: currentMonitor.code,
          }"
          :code="currentMonitor.code"
          :name="currentMonitor.name"
          :pIid="currentMonitor.pIid"
          :showControlPanel="false"
          class="h-210px mt-15px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { FileApi } from '@wiz-api/file-management'
import { PersonnelApi } from '@wiz-api/personnel-position'
import { VisitorApi } from '@wiz-api/visitor-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { isEmpty, isEqual, find, filter, map, forEach, get } from 'lodash'
import dayjs from 'dayjs'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const fileApi = new FileApi()
const personnelApi = new PersonnelApi()
const visitorApi = new VisitorApi()
const dataCategoryApi = new DataCategoryApi()
const personnelLocationApi = new PersonnelLocationApi()

const MonitorPlayer = () => {
  return import('./components/video/MonitorPlayer')
}
const CategoryTitle = () => {
  return import('@/components/cockpit/CategoryTitle')
}

export default {
  components: {
    MonitorPlayer,
    CategoryTitle,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      personnelDetail: {},
      isFollow: false,
      // 默认跟随
      currentBtn: '',
      // 所有人员的信息
      allPersonnelInfo: [],
      // code和id的映射
      codeIdMap: {},
      // 处理数据的标识
      flag: true,
      // 是否查看历史轨迹
      isTrajectory: false,
      documentTypeList: [],
      currentMonitor: null,
      followTimer: null,
    }
  },
  computed: {
    personnelId() {
      console.log(this.transferProps)
      return this.transferProps.personnelId
    },
    tagCode() {
      return this.transferProps.tagCode
    },
    online() {
      return this.transferProps.online
    },
    // 附近的人最大距离筛选
    nearMaxDistance() {
      return (
        get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.nearMaxDistance || 5
      )
    },
    usersInfo() {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      return userInfo?.profile || {}
    },
  },
  watch: {
    transferProps: {
      immediate: true,
      async handler(value) {
        // 如果是从历史轨迹的人员标签打开的人员详情弹框
        if (value.isTrajectory) {
          this.currentBtn = 'trajectory'
          this.isTrajectory = true
          if (this.isFollow) {
            if (this.followTimer) {
              clearInterval(this.followTimer)
              this.followTimer = null
            }
            // 取消跟随
            await this.cloudRender.PosViewer.cancelPerspectiveFollow()
            this.isFollow = false
          }
        } else {
          // 如果不是从历史轨迹中点击标签打开的，则跟随人员
          if (!this.isFollow) {
            this.getNearbyCamera()
            this.followTimer = setInterval(() => {
              this.getNearbyCamera()
            }, 5000)
            await this.cloudRender.PosViewer.setPerspectiveFollow({
              id: this.tagCode,
              personalPerspective: 2,
              angle: [5, 90],
            })
            this.isFollow = true
          }
          this.currentBtn = 'locationTracking'
        }
        await this.getCategoryByCodes()
        await this.getPersonnelDetail(this.personnelId)
      },
    },
    currentBtn(value) {
      if (value === 'trajectory') {
        // 打开历史轨迹的弹框
        this.$emit('operateTrajectory', {
          visible: true,
          personnelId: this.personnelId,
          tagCode: this.tagCode,
        })
      }
    },
  },
  async created() {
    // await this.getPersonnelDetail(this.personnelId)
    // await this.getAllPersonnelInfo()
    // await this.getCodeIdMap()
  },
  mounted() {
    // 监听实时人员数据更新的事件
    window.addEventListener('setNearByList', this.positionListHandler)
    // 监听取消跟随的时间
    window.addEventListener('cancelFollow', this.cancelFollowHandler)
    // 监听是否查看历史轨迹事件
    window.addEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    this.cloudRender.Dispatch.on('PosViewerMarker', this.markerClick)
  },
  methods: {
    markerClick(e) {
      // 左键点击并且有id
      if (e.type === 1 && !isEmpty(e.id)) {
        if (this.tagCode === e.id) {
          this.currentBtn = 'locationTracking'
          this.isFollow = true
        }
      }
    },
    // 获取附近摄像头
    async getNearbyCamera() {
      if (!this.online) return
      const [err, res] = await personnelLocationApi.getPersonNearbyCameras({
        body: {
          modelId: this.customProps?.sceneId,
          x: this.online.x,
          y: this.online.y,
          z: this.online.z,
        },
      })
      if (!err && res.length) {
        if (!isEqual(this.currentMonitor, res[0])) {
          this.currentMonitor = null
          this.currentMonitor = res[0]
        }
      }
    },
    // 数据字典获取图标类型
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['DocumentType'],
        includeDetails: true,
      })
      if (!err && res.length) {
        this.documentTypeList = res[0].dataItems || []
      }
    },
    // 获取人员详情信息
    async getPersonnelDetail(personnelId) {
      const [err, res] = await visitorApi.get(personnelId)
      if (!err && !isEmpty(res)) {
        const sexMap = {
          0: '男',
          1: '女',
        }
        const documentType = `${res.documentType}`
        this.personnelDetail = {
          ...res,
          sexStr: sexMap[res.sex],
          documentTypeName: find(this.documentTypeList, {
            code: documentType,
          })?.displayName,
          validTime: `${dayjs(res.validStartTime).format('YYYY-MM-DD')}-${dayjs(
            res.validEndTime
          ).format('YYYY-MM-DD')}`,
          visitProductionAreaStr: res.visitProductionArea ? '是' : '否',
          documentImg: await this.getImgContent(res.documentFront),
          facePhotoImg: await this.getImgContent(res.facePhoto),
        }
      }
    },
    // 获取图片base64
    async getImgContent(fileId) {
      // 获取图片内容
      const [error, result] = await visitorApi.getFileContent(fileId, {
        tenantId: this.usersInfo.tenantid,
      })
      if (!error && !isEmpty(result)) {
        return `data:image/png;base64,${result.content}`
      }
      return ''
    },
    // 跟随操作
    async track() {
      if (this.isTrajectory) {
        return this.$message.warning({
          showClose: true,
          message: '请先退出轨迹查询',
        })
      }
      this.currentBtn = 'locationTracking'
      if (this.isFollow) {
        if (this.followTimer) {
          clearInterval(this.followTimer)
          this.followTimer = null
        }
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      } else {
        this.getNearbyCamera()
        this.followTimer = setInterval(() => {
          this.getNearbyCamera()
        }, 5000)
        // 跟随人员
        await this.cloudRender.PosViewer.setPerspectiveFollow({
          id: this.tagCode,
          personalPerspective: 2,
          angle: [5, 90],
        })
      }
      this.isFollow = !this.isFollow
    },
    // 获取所有人员信息
    async getAllPersonnelInfo() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && !isEmpty(res)) {
        this.allPersonnelInfo = res.items
      }
    },
    // 获取code和id的映射
    async getCodeIdMap() {
      const [err, res] = await personnelApi.getPersonnelPostionList({
        isBind: true,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && !isEmpty(res)) {
        forEach(res, (item) => {
          this.codeIdMap[item.tagCode] = item.id
        })
      }
    },
    async searcheTrajectory() {
      this.currentBtn = 'trajectory'
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    async cancelFollowHandler() {
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    // 监听是否查看历史轨迹
    historicalTrajectoryHandler(e) {
      this.isTrajectory = e.detail?.isOpen
      if (!e.detail?.isOpen && this.currentBtn === 'trajectory') this.currentBtn = ''
    },
  },
  beforeDestroy() {
    // 解绑事件
    window.removeEventListener('cancelFollow', this.cancelFollowHandler)
    window.removeEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    this.cloudRender.Dispatch.off('PosViewerMarker', this.markerClick)
    if (this.isFollow) {
      // 取消跟随
      this.cloudRender.PosViewer.cancelPerspectiveFollow()
    }
    if (this.followTimer) {
      clearInterval(this.followTimer)
      this.followTimer = null
    }
  },
}
</script>

<style lang="scss" scoped>
.btn_normal {
  background: url('../../assets/images/button_blue.png');
  background-size: 100% 100%;
}

.btn_choosed {
  background: url('../../assets/images/button_yellow.png');
  background-size: 100% 100%;
}

.table-choosed {
  background: url('../../assets/images/control/table_choosed.png');
  background-size: 100% 100%;
}

.head-bg {
  background: url('../../assets/images/control/table_head.png');
  background-size: 100% 100%;
}

.area-box {
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 9px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #104a70;
    color: #104a70;
  }
}
</style>
